module.exports = __webpack_public_path__ + "media/bootstrap-icons/tablet-fill-d4c5a6b9.svg";